<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
    <section class="hero-section ptb-100" style="background:#00A39C">
        <div class="container">
            <div class="row align-items-center justify-content-center">
                <div class="col-md-9 col-lg-7">
                    <div class="page-header-content text-white text-center pt-sm-5 pt-md-5 pt-lg-0">
                        <h1 class="text-white mb-0">Escuela virtual</h1>
                        <div class="custom-breadcrumb">
                            <ol class="breadcrumb d-inline-block bg-transparent list-inline py-0">
                                <li class="list-inline-item breadcrumb-item"><a href="#">Inscripción, información del curso, horarios y preguntas frecuentes.</a></li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section class="customer-review-section ptb-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-11 col-md-11">
                    <div class="card border-0 card-details">
                        <div class="row">
                            <div class="col-sm-2">
                                <img :src="listDetailsCourse[0].img" alt="client" class="img-fluid w-100">
                            </div>
                            <div class="col-sm-10">
                                <div class="media-body">
                                    <h3 class="mb-0 entry-title" v-text="listDetailsCourse[0].title"></h3>
                                    <p class="lead mb-1" v-text="listDetailsCourse[0].description"></p>
                                    <button v-if="listDetailsCourse[0].shopping == 0" class="btn warning-btn my-0" @click="rVirtual">Comprar ahora</button>
                                    <el-alert v-else
                                      type="warning"
                                      :closable="closable"
                                      description="Ya finalizaron las inscripciones del mes."
                                      show-icon>
                                    </el-alert>
                                </div>
                            </div>
                        </div>
                        <el-divider></el-divider>
                        <div class="d-flex align-items-center flex-wrap my-8 mb-4">
                            <!--begin::Item-->
                            <div v-if="listDetailsCourse[0].scheduls.length==1" class="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                                <span class="mr-4">
                                    <i class="el-icon-time display-4 text-muted"></i>
                                </span>
                                <div class="d-flex flex-column text-dark-75">
                                    <span class="font-weight-bolder font-size-sm">Horario</span>
                                    <span class="option-body" style="line-height:1.2">
                                        <span class="text-dark-50" v-html="listDetailsCourse[0].scheduls[0].schedule"></span></span>
                                </div>
                            </div>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <div v-if="listDetailsCourse[0].teachers.length==1" class="d-flex align-items-center mr-10 mb-2">
                                <div class="symbol symbol-circle symbol-success mx-2">
                                    <img alt="Pic" class="img-fluid rounded-circle" width="50px" :src="listDetailsCourse[0].teachers[0].img">
                                </div>
                                <div class="d-flex flex-column text-left">
                                    <span class="font-weight-bolder font-weight-bold">Docente</span>
                                    <span class="text-success font-weight-bold" v-text="listDetailsCourse[0].teachers[0].firstname"></span>
                                </div>
                            </div>
                            <!--begin::Item-->

                            <div class="d-flex align-items-center flex-lg-fill ml-5 mr-5 mb-2">
                                <span class="mr-4">
                                    <i class="el-icon-goods display-4 text-muted"></i>
                                </span>
                                <div class="d-flex flex-column text-dark-75">
                                    <span class="font-weight-bolder font-size-sm">Costo</span>
                                    <span class="font-weight-bolder font-size-h5">
                                        <span class="text-dark-50 font-weight-bold" v-text="'S/ '+listDetailsCourse[0].price"></span></span>
                                </div>
                            </div>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <div class="d-flex align-items-center flex-lg-fill mr-5 mb-2">
                                <span class="mr-4">
                                    <i class="el-icon-date display-4 text-muted"></i>
                                </span>
                                <div class="d-flex flex-column text-dark-75">
                                    <span class="font-weight-bolder font-size-sm">Inicia</span>
                                    <span class="font-weight-bolder font-size-h5">
                                        <span class="text-dark-50 font-weight-bold"></span>{{listDetailsCourse[0].startdate | moment('DD [de] MMMM')}}</span>
                                </div>
                            </div>
                        </div>
                        <!--<el-divider></el-divider>-->
                        <el-tabs v-model="activeName">
                            <el-tab-pane label="Información del curso" name="first" v-html="listDetailsCourse[0].content"></el-tab-pane>
                            <el-tab-pane v-if="listDetailsCourse[0].scheduls.length>1" label="Horarios" name="second">
                                <div class="row">

                                    <div v-for="item in listDetailsCourse[0].scheduls" :key="item.idschedule" class="col-lg-12">
                                        <label class="option mb-2">
                                            <span class="option-label border-right w-50 mr-4">
                                                <span class="option-head">
                                                    <span class="option-title">{{item.title}} (Inicia {{item.startdate |  moment('DD [de] MMMM')}}) </span>
                                                </span>
                                                <span class="option-body pt-0" v-html="item.schedule"></span>
                                            </span>
                                            <div class="d-flex align-items-center">
                                                <div class="symbol symbol-circle symbol-success mx-2">
                                                    <img alt="Serpar" :src="'https://apv.serpar.gob.pe/assets/media/teachers/'+item.img">
                                                </div>
                                                <div class="d-flex flex-column text-left">
                                                    <span class="text-muted font-weight-bold">Docente</span>
                                                    <span class="text-success font-weight-bold" v-text="item.firstname + item.lastname"></span>
                                                </div>
                                            </div>
                                        </label>
                                    </div>
                                </div>

                            </el-tab-pane>
                            <el-tab-pane label="Preguntas frecuentes" name="third" v-html="preguntas"></el-tab-pane>
                        </el-tabs>

                    </div>

                    <div class="bg-ticket rounded my-2 p-3 bg-light">
                        <div class="row align-items-center justify-content-center">
                            <div class="col-8 col-lg-3">
                                <h6 class="mb-0">
                                    Mira cómo comprar aquí
                                </h6>
                            </div>
                            <div class="col-4 col-lg-2">
                                <a href="https://youtu.be/4zYB9YMuEc4" target="_blank">
                                    <span class="svg-icon svg-icon-4x">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <rect x="0" y="0" width="24" height="24" />
                                                <path d="M4.22266882,4 L19.8367728,4.00001353 C21.3873185,4.00001353 22.6823897,5.1816009 22.8241881,6.72564925 C22.9414021,8.00199653 23.0000091,9.40113909 23.0000091,10.9230769 C23.0000091,12.7049599 22.9196724,14.4870542 22.758999,16.26936 L22.7589943,16.2693595 C22.6196053,17.8155637 21.3235899,19 19.7711155,19 L4.22267091,19.0000022 C2.6743525,19.0000022 1.38037032,17.8217109 1.23577882,16.2801587 C1.07859294,14.6043323 1,13.0109461 1,11.5 C1,9.98905359 1.07859298,8.39566699 1.23577893,6.7198402 L1.23578022,6.71984032 C1.38037157,5.17828994 2.67435224,4 4.22266882,4 Z" fill="#000000" opacity="0.3" />
                                                <path d="M11.1821576,14.8052934 L15.5856084,11.7952868 C15.8135802,11.6394552 15.8720614,11.3283211 15.7162299,11.1003494 C15.6814583,11.0494808 15.6375838,11.0054775 15.5868174,10.970557 L11.1833666,7.94156929 C10.9558527,7.78507001 10.6445485,7.84263875 10.4880492,8.07015268 C10.4307018,8.15352258 10.3999996,8.25233045 10.3999996,8.35351969 L10.3999996,14.392514 C10.3999996,14.6686564 10.6238572,14.892514 10.8999996,14.892514 C11.000689,14.892514 11.0990326,14.8621141 11.1821576,14.8052934 Z" fill="#000000" />
                                            </g>
                                        </svg>
                                      </span></a>
                            </div>
                            <div class="col-8 col-lg-3 mt-4 mt-md-0">
                                <h6 class="mb-0">
                                    Contáctate con nosotros
                                </h6>
                            </div>
                            <div class="col-4 col-lg-2 mt-4 mt-md-0">
                                <a href="https://wa.link/cvwvgf" target="_blank" rel="noopener noreferrer">
                                    <span class="svg-icon svg-icon-4x">
                                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <rect x="0" y="0" width="24" height="24" />
                                                <path opacity="0.3" fill-rule="evenodd" clip-rule="evenodd" d="M14.4862 18L12.7975 21.0566C12.5304 21.54 11.922 21.7153 11.4386 21.4483C11.2977 21.3704 11.1777 21.2597 11.0887 21.1255L9.01653 18H5C3.34315 18 2 16.6569 2 15V6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V15C22 16.6569 20.6569 18 19 18H14.4862Z" fill="black" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H6C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7ZM6 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11Z" fill="black" />
                                            </g>
                                        </svg>
                                      </span>
                                </a>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </section>

</div>
</template>

<script>
export default {
    data() {
        return {
            closable:false,
            slug: '',
            activeName: 'first',
            listDetailsCourse: [],
            fullscreenLoading: false,
            preguntas: `<br><h5 class="mb-4">&iquest;C&oacute;mo son las clases y el acceso al curso?</h5>
<p>Las clases se brindan en vivo, a trav&eacute;s de ZOOM, una plataforma virtual mediante la cual los profesores ense&ntilde;an e interact&uacute;an con los alumnos. Cada clase queda grabada y puede visualizarse en el campus virtual para que los participantes puedan volver a verlas y seguir practicando en casa. Asimismo, podr&aacute;n encontrar tutoriales y consejos que complementen su aprendizaje.</p>
<h5 class="mb-4">&iquest;C&oacute;mo me inscribo?</h5>
<p>Luego de elegir la escuela de tu inter&eacute;s, debes darle clic a "<strong>Comprar ahora</strong>" donde elegir&aacute;s el horario e ingresar&aacute;s tus datos para completar la inscripci&oacute;n. Realiza el pago ingresando los datos de tu tarjeta de cr&eacute;dito o d&eacute;bito.</p>
<p><br /> Puedes comunicarte al 945 503 022 para cualquier consulta.</p>
<h5 class="mb-4">&iquest;C&oacute;mo accedo a las clases virtuales?</h5>
<p>Cuando hayamos confirmado tu inscripci&oacute;n, te enviaremos un correo electr&oacute;nico con el enlace de la sala de ZOOM a la que ingresar&aacute;s para recibir las clases virtuales. As&iacute;, como tu acceso al campus virtual donde encontrar&aacute;s las clases grabadas y tutoriales para complementar tu aprendizaje. </p>`

        }
    },
    methods: {
        getDetailsCourse() {
            this.fullscreenLoading = true;
            var formdata = new FormData();
            formdata.append('slug', this.slug);
            axios.post(`${process.env.API1}/virtual/details`, formdata).then(response => {
                this.listDetailsCourse = response.data;
                this.fullscreenLoading = false;
            });
        },
        rVirtual() {
            this.$router.push({
                path: `/rvirtual/${this.slug}`
            })
        }
    },
    created() {
        this.slug = this.$route.params.slug;
        this.getDetailsCourse();
    }

}
</script>

<style>
.card-details .el-alert__description{font-size:15px;}
</style>



// WEBPACK FOOTER //
// src/components/pages/evirtual/courseDetails.vue